module.exports = __webpack_public_path__ + "static/media/ShapesBlue.ebd680d0.svg";